import { QuestionCircleOutlined } from '@ant-design/icons'
import {Flex, Switch, Tooltip} from 'antd'
import { ReactNode } from 'react'


interface Props<T> {
    entity: T
    setEntity: (entity: T) => void
    tooltip?: ReactNode
}

export const StatusSwitch = <T extends object>({entity, setEntity, tooltip}: Props<T>) =>
    <Flex align="center">
        <span style={{marginRight: 8}}>Active</span>
        {tooltip && (
            <Tooltip title={tooltip}>
                <QuestionCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 14, marginRight: 8 }} />
            </Tooltip>
        )}
        <Switch size="small" checked={entity['active']} onChange={(value) => setEntity({...entity, active: value})}/>
    </Flex>
